// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/enroute-position-reports.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/enroute-position-reports/broadcast-before-action-and-mf-entry.js';
import g1 from '../lessons/air-law/enroute-position-reports/enroute-position-reports.js';
import g2 from '../lessons/air-law/enroute-position-reports/practice-area-calls.js';
import g3 from '../lessons/air-law/enroute-position-reports/vfr-position-report-format.js';

mount([g0, g1, g2, g3]);
